module.exports = __webpack_public_path__ + "static/media/polytope_3_52_5_layers_3_3.8bb00025.gif";